import React, { useState } from "react";
import "./PinPointForm.css";
import { Form, Button, Card, Alert } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { formConfigData } from "../formConfigData";

function PinPointForm(props) {
  const [formInputFields, setformInputFields] = useState({
    relatedToLand: "",
    nearestCommunity: "",
    whoAreYou: "",
    assetName: "",
    assetThreatRisk: "",
    assetProtectMethodAlready: "",
    assetProtectMethodSuggestion: "",
    whyImportant: "",
    userInfo: "",
  });

  const [loading, setLoading] = useState(false);

  const closeForm = () => {
    document.querySelector(".pin-form").classList.toggle("hide");
    setLoading(false);
  };

  return (
    <div className="pin-form hide">
      <Card>
        <div className="pin-form__close">
          <IconButton onClick={closeForm}>
            <CloseIcon />
          </IconButton>
        </div>
        <Card.Body>
          <h2 className="text-center mb-4">
            {" "}
            {props.updatePinPointsButtonClickedRef.current === true
              ? "Update"
              : "Add"}{" "}
            Point
          </h2>

          <Form
            className="pin-form-form"
            onSubmit={async (event) => {
              setLoading(true);

              if (props.updatePinPointsButtonClickedRef.current === true) {
                await props.handlePinPointFormUpdateSubmit(
                  event,
                  formInputFields
                );
              } else {
                await props.handlePinPointFormAddSubmit(event, formInputFields);
              }

              setLoading(false);
              // resetting the state for next use
              var tempformInputFields = formInputFields;
              Object.keys(tempformInputFields).forEach(function (key, index) {
                tempformInputFields[key] = "";
              });
              setformInputFields(tempformInputFields);
            }}
          >
            {Object.keys(formConfigData).map((key, index) => {
              return (
                <Form.Group id={key} key={index} className="pin-form-field">
                  <Form.Label>
                    {formConfigData[key].question}
                    <br />
                    <span className="pin-form__question-detail">
                      {formConfigData[key].detail}
                    </span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={formInputFields[`${key}`]}
                    onChange={(e) => {
                      setformInputFields({
                        ...formInputFields,
                        [`${key}`]: e.target.value,
                      });
                    }}
                    className={key}
                    required
                  />
                </Form.Group>
              );
            })}
            <div className="pin-form-buttons">
              <Button
                disabled={loading}
                className="pin-form-field"
                type="submit"
              >
                {props.updatePinPointsButtonClickedRef.current === true
                  ? "Update"
                  : "Add"}
              </Button>
              <Button className="pin-form-field" onClick={closeForm}>
                Cancel
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}

export default PinPointForm;
